export const REGIONS_WITH_OVERVIEW_BLOCKS_SELECT_CONSTS = {
  allRegionsMsg: 'Все регионы',
  checkAllMsg: 'Выбрать все',
  dontShowMsg: 'Не выводить',
  regionsMsg: 'Регионы',
  selectPositionMsg: 'Выбрать позицию в картине дня'
}
